export { default } from './MegaMenuTrigger';
